<template>
  <v-container class="ed-filter">
    <v-row class="pt-2">
      <v-col cols="12" sm="3" :md="type ? 3 : 4" class="pt-0 pb-0">
        <v-autocomplete
          dense
          outlined
          v-model="business_selected"
          :items="bussines_units"
     
          @change="setLocation"
          label="Unidad de negocio"
          color="cyanText"
          prepend-inner-icon="corporate_fare"
          required
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" :md="type ? 3 : 4" class="pt-0 pb-0">
        <v-autocomplete
          dense
          outlined
          v-model="location_selected"
          return-object
          :items="locationsFrombusiness"
          @input=" changeLocation()"
          color="cyanText"
          label="Location"
          prepend-inner-icon="my_location"
          required
        >
          <template v-slot:no-data>
            <div class="px-4">Seleciona la unidad de negocio</div>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col v-if="type" cols="12" sm="4" md="2" class="pt-0 pb-0">
        <v-autocomplete
          dense
          outlined
          v-model="filters.department_id"
          :items="itemsDepartment"
          @input="sendEmit()"
          return-object
          color="cyanText"
          label="Departamento"
          prepend-inner-icon="business"
          required
        ></v-autocomplete>
      </v-col>
      <v-col v-if="viewPeriods" cols="12" sm="4" md="4" class="pt-0 pb-0">

        <v-autocomplete
          v-model="current_period"
          :items="periods"
          label="Periodo"
          item-text="name"
          @change="changePeriod"
          prepend-inner-icon="mdi-sitemap-outline"
          item-value="id"
          outlined
          dense
          hide-details
        >
          <template v-slot:selection="data">
            <span v-html="data.item.name"></span>
          </template>
          <template v-slot:item="data">
            <div v-html="data.item.name"></div>
          </template>
          <template v-slot:no-data>
            <span class="red--text mx-2"> Selecciona un calendario</span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col v-if="showRefresh" cols="12" md="1" class="mt-n2">
        <v-btn icon size="40px" @click="sendEmit()"
          ><v-icon size="35px" color="success">refresh</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    bussines_units: [],
    itemsDepartment: [],
    current_period: null,
    current_calendar: null,
    filters: {
      business: null,
      location: null,
      department_id: null,
    },
    periods: [],
    calendars: [],
  }),
  props: {
    type: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Boolean,
      default: true,
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },

    viewPeriods: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.initialized();
  },

  computed: {
    business_selected: {
      get() {
        return this.$store.state.app.filters.business;
      },
      set(value) {
        this.$store.commit("setBusiness", value);
      },
    },
    location_selected: {
      get() {
        return this.$store.state.app.filters.location;
      },
      set(value) {
        // Si value es un ID (número), buscar el objeto completo
        if (typeof value === 'number' && value !== null) {
          const locationObject = this.$store.state.auth.locations.find(
            location => location.id === value || location.value === value
          );
          // Si encontramos el objeto, usarlo; si no, usar el valor original
          this.$store.commit("setLocation", locationObject || value);
        } else {
          // Si ya es un objeto o null, usarlo directamente
          this.$store.commit("setLocation", value);
        }
      },
    },
    locationsFrombusiness() {
      let locations = Object.assign(
        [],
        this.$store.state.auth.locations.filter(
          (element) => element.bus_id == this.filters.business
        )
      );
      if (locations.length > 1) {
        locations.unshift({ id: 0, value: 0, text: "Todos" });
      }
      //    this.filters.location = locations[0].id;
      return locations;
    },
  },
  watch: {},
  methods: {
    setLocation() {
      if (this.business_selected != 0 || this.business_selected != null) {
        if (this.locationsFrombusiness.length > 0) {
          this.filters.location = this.locationsFrombusiness[0].id;
        }
      } else {
        this.filters.location = null;
      }
      this.filters.business = this.business_selected;
      this.sendEmit()
    },
    changeLocation () {
      // Manejar tanto objetos como IDs para location_selected
      const locationId = typeof this.location_selected === 'object' && this.location_selected !== null 
        ? this.location_selected.id || this.location_selected.value
        : this.location_selected;
      
      this.filters.location = locationId;
      this.sendEmit();
    },
    async getCalendars(filters) {
      if (filters.business == null || filters.business == 0) {
        return;
      }
      this.calendars = [];

      const data = await this.api_Post(
        "accounting/calendar_periods_revaluate",
        {
          id: filters.business,
        }
      );
      let result = await data.json();
      this.calendars = result;
    },

    showPeriods(id) {
      this.periods = [];

      let data = this.calendars.find(
        (element) => element.accounting_calendar_id == id
      );
      let per = [];
      data.periods.forEach((element) => {
        let name =
          `<span style="color:blue;">Periodo: ${element.accounting_period_id}</span> - ` +
          moment(element.date_from).format("MMMM").toString();

        per.push({ name: name, ...element });
      });
      per.sort((a, b) => a.accounting_period_id - b.accounting_period_id);

      this.periods = per;
    },
    changePeriod() {
      this.sendEmit();
    },
    async initialized() {
      this.editedItem = Object.assign(
        {},
        this.$store.state.auth.bussines_units
      );
      this.bussines_units = Object.assign(
        [],
        this.$store.state.auth.bussines_units
      );
      if (this.business_selected) {
        this.filters.business = this.business_selected;
      }
      if (this.location_selected) {
        // Manejar tanto objetos como IDs para location_selected
        const locationId = typeof this.location_selected === 'object' && this.location_selected !== null 
          ? this.location_selected.id || this.location_selected.value
          : this.location_selected;
        this.filters.location = locationId;
      }

      this.itemsDepartment.unshift({ text: "Todos", value: 0 });
      this.filters.department_id = this.itemsDepartment[0].value;
      await this.getCalendars(this.filters);

      //this.current_period=this.periods.find(element=>element.accounting_period_id==this.filters.period_id)
      this.sendEmit();
    },
    sendEmit() {
 

      if(this.calendars.length>0){
  {
    this.showPeriods(this.calendars[0].accounting_calendar_id);
  }
} 
      if (this.current_period == null) {
        const today = moment();

        const currentPeriod = this.periods.find((period) => {
          const dateFrom = moment(period.date_from);
          const dateTo = moment(period.date_to);
          return today.isBetween(dateFrom, dateTo, null, "[]");
        });

        if (currentPeriod) {
          this.current_period = currentPeriod.id;
          this.filters.period_id = currentPeriod.id;
          this.filters.from_date = currentPeriod.date_from;
          this.filters.to_date = currentPeriod.date_to;
        }
      } else {
        let period_selected = null;
        this.periods.forEach((element) => {
          if (element.id == this.current_period) {
            period_selected = element;
          }
        });

        this.filters.period_id = this.current_period;

        this.filters.from_date = period_selected.date_from;
        this.filters.to_date = period_selected.date_to;
      }
  
      if(this.filters.location==undefined){
        this.filters.location=0
      }
      this.$emit("filter_loaded", this.filters);
    },
  },
};
</script>

<style lang="scss" scoped>
$ink:    #0E1B2C;
$graph:  #4B5A6B;
$muted:  #8A98AB;
$rule:   #D9DEE6;
$paper-soft: #FBF9F4;

$display: 'Fraunces', Georgia, serif;
$sans:    'Inter Tight', sans-serif;

.ed-filter {
  padding: 0 !important;
}

::v-deep .v-input--is-focused fieldset {
  border-color: $ink !important;
  border-width: 1px !important;
}
::v-deep .v-input fieldset {
  border-color: $rule !important;
  border-radius: 2px !important;
}
::v-deep .v-input__slot {
  background: $paper-soft !important;
  min-height: 46px !important;
}
::v-deep .v-label {
  font-family: $sans !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: .14em !important;
  text-transform: uppercase !important;
  color: $graph !important;
}
::v-deep .v-select__selection,
::v-deep .v-select__selection--comma {
  font-family: $display !important;
  font-size: 16px !important;
  color: $ink !important;
  letter-spacing: -.01em !important;
}
::v-deep .v-icon { color: $graph !important; }

// Refresh icon button — match editorial brass accent
::v-deep .v-btn--icon .v-icon[color="success"] {
  color: #B68A3E !important;
}
</style>
